import { z } from 'zod';
import { EmptyValidationMessage, FieldValues, Path, mapDropDown } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { useSalaryBands } from '../../../../app-init-data';

export const usePrincipalSalaryBandField = <TForm extends FieldValues>(isHidden?: boolean) => {
	const { translate: t } = useAppPlatformContextOptions();

	const { salaryBands } = useSalaryBands();

	const getField = ({ field }: { field: Path<TForm> }) =>
		mapDropDown({
			field,
			label: t('members:fields.salary-band.label'),
			options: salaryBands,
			valueKey: 'id',
			labelKey: 'name',
			placeholder: t('members:fields.salary-band.placeholder'),
			isHidden,
		});

	const getValidation = () =>
		z.number({
			required_error: EmptyValidationMessage,
		});

	return {
		getField,
		getValidation,
	};
};
